module.exports = __webpack_public_path__ + "img/member-ad-04.0e62a55c.png";